<template>
  <VExpansionPanels v-bind="$props">
    <slot />
  </VExpansionPanels>
</template>

<script>
import { VExpansionPanels } from 'vuetify/lib';

/**
 * @component WorkExpansionPanels
 * @description Wrapper around Vuetify `VExpansionPanels`.
 * Passes all props from `VExpansionPanels` through.
 *
 * @slot default - Expansion panel entries.
 */
export default {
  name: 'WorkExpansionPanels',
  components: {
    VExpansionPanels,
  },
  props: { ...VExpansionPanels.options.props },
};
</script>
